import { gql } from '@apollo/client'

import { iconViewFieldsFragment } from 'js/lib/fragments/IconViewFields.fragment'

import { magazineArticleViewFragment } from './MagazineArticleView.fragment'

export const magazineIssueViewFragment = gql`
    fragment MagazineIssueView on MagazineIssue {
        guid
        url
        canEdit
        statusPublished
        canArchiveAndDelete
        issueNumber
        backgroundColor
        timePublished
        container {
            guid
            ... on Magazine {
                title
                url
                subtitle
                icon {
                    ...IconViewFields
                }
            }
        }
        colophon {
            key
            value
            label
        }
        articles {
            guid
            ...MagazineArticleView
        }
    }
    ${iconViewFieldsFragment}
    ${magazineArticleViewFragment}
`
